// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2VXRC","tab":"ProcedureTabs_tab__a0bRD"};